import { Plane, Program, Mesh, Texture } from 'ogl'
import vertex from './shaders/smoke/vertex.glsl'
import fragment from './shaders/smoke/fragment.glsl'
import smoke from 'Images/smoke.png'

export default class Smoke {

  constructor({ gl, scene, count }) {
    this.gl = gl
    this.scene = scene
    this.count = count || 5
    this.mesh = []
    //Methods
    this.createGeometry()
    this.createTexture()
    this.createProgram()
    this.createMesh()

  }

  createGeometry() {
    //  
    this.geometry = new Plane(this.gl, {
      width: 1024,
      height: 1024,
      widthSegments: 1,
      heightSegments: 1
    })
  }

  createTexture() {
    //
    this.texture = new Texture(this.gl, {
      generateMipmaps: false,
    })

    //
    const image = new Image()
    image.src = smoke
    image.crossOrigin = 'anonymous'
    image.onload = () => {
      this.texture.image = image
      // this.texture.width = image.naturalWidth
      // this.texture.height = image.naturalHeight
    }
  }

  createProgram() {
    this.program = new Program(this.gl, {
      vertex,
      fragment,
      uniforms: {
        uMask: { value: this.texture },
        uTime: { value: 0 },
        uProgress: { value: 0 },
        uSize: { value: 1 },
        uResolution: { value: { width: window.innerWidth, height: window.innerHeight } }
      },
      transparent: true,
      depthTest: true,
      depthWrite: true,
      cullFace: null
    })
  }

  createMesh() {
    
    for (let i = 0; i < this.count; i++) {
      const item = {}

      item.speed = Math.random() * 0.1 + .1
      this.program.uniforms.uProgress.value = Math.random() * 1.5 + 0.2;      
      //
      item.mesh = new Mesh(this.gl, {
        // mode: this.gl.LINE_STRIP,
        geometry: this.geometry,
        program: this.program
      })
      
      //    
      item.mesh.position.set((Math.random() * 2 - 1) , -Math.random(), (Math.random() * 2 - 1) * -2)
      //
      this.scene.addChild(item.mesh)
      //
      this.mesh.push(item)

    }

  }

  onResize(viewport) {
    this.viewport = viewport
    this.program && (this.program.uniforms.uResolution.value = { width: this.viewport.width, height: this.viewport.height })
  }

  update(time) {
    this.program && (this.program.uniforms.uTime.value = time)
    
      this.mesh && this.mesh.forEach(item => {        
        item.mesh.rotation.z = time * item.speed + .1
        item.mesh.position.y += Math.sin(time * item.speed)
        
      })
    
  }

}